import React, { useState, useEffect } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { StorageHandler, RewardMenu, APIHandler, ContentHeader } from 'C4';
import { storageKeys, baseAppId } from 'settings';
import i18n from 'i18n-react';

const ALLOWED_COUNTRIES = ['gb', 'de', 'fr', 'au']; // List of allowed countries

const RewardsView = () => {
  const [email, setEmail] = useState('');
  const [points, setPoints] = useState([]);
  const [isAllowed, setIsAllowed] = useState(false);

  useEffect(() => {
    const checkCountry = async () => {
      const langData = await StorageHandler.load(storageKeys.lang);
      const countryCode = langData?.code?.toLowerCase();
      setIsAllowed(ALLOWED_COUNTRIES.includes(countryCode));
    };

    checkCountry();
  }, []);

  useEffect(() => {
    if (!(points.total >= 0)) {
      StorageHandler.load(storageKeys.accessToken).then((token) => {
        const startDate = '2021-07-21';
        const endDate = '2023-12-21';
        APIHandler.getPoints(baseAppId, startDate, endDate, token).then((res) => {
          setPoints(res.total);
        });
      });
    }
  }, [points, setPoints]);

  useEffect(() => {
    document.body.classList.remove('no-scroll');
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        setEmail((prev) => (res.email !== prev ? res.email : prev));
      }
    });
  }, [email, setEmail]);

  return (
    <div className="contentContainer rewardsView">
      <RewardMenu />

      <div className="bodyRewards">
        <div className="holder">
          <ContentHeader header={i18n.translate('rewards.title')} subtitle={i18n.translate('rewards.subheader')} />

          <hr />

          <div className="rewardsCenter">

            <div className="rewardsCenter__content">
              <h4>
                <b>{i18n.translate('rewards.overview.subtitle')}</b>
                <br /> <br />
                {i18n.translate('rewards.overview.description')}
                <br />
              </h4>
              <ul>
                <li>
                  <h2>{i18n.translate('rewards.overview.dashboard.title')}</h2>
                </li>
                <li>{i18n.translate('rewards.overview.dashboard.description')}</li>
              </ul>
              <ul>
                <li>{i18n.translate('rewards.overview.dashboard.bronze')}</li>
                <li>{i18n.translate('rewards.overview.dashboard.silver')}</li>
                <li>{i18n.translate('rewards.overview.dashboard.gold')}</li>
                <li>{i18n.translate('rewards.overview.dashboard.platinum')}</li>
              </ul>
              <ul>
                <li>
                  <h2>{i18n.translate('rewards.overview.platinumRewards.title')}</h2>
                </li>
                <li>{i18n.translate('rewards.overview.platinumRewards.description')}</li>
              </ul>
              <ul>
                <li>
                  <h2>{i18n.translate('rewards.overview.downloads.title')}</h2>
                </li>
                <li>{i18n.translate('rewards.overview.downloads.description')}</li>
              </ul>
            </div>
          </div>

          <hr />

          <Link to="/main/rewards/achievements" className="linkRewards">
            <ContentHeader
              icon={['fas', 'bars']}
              header={i18n.translate('rewards.home.trainingAchievements')}
              subtitle={i18n.translate('rewards.home.trainingAchievementsText')}
              layout="row"
            />
          </Link>

          <hr />

          {/* Show these only if the country is allowed */}
          {isAllowed && (
            <>
              <Link to="/main/rewards/bookings" className="linkRewards">
                <ContentHeader
                  icon={['far', 'badge']}
                  header={i18n.translate('rewards.home.bookingDashboard')}
                  subtitle={i18n.translate('rewards.home.bookingDashboardText')}
                  layout="row"
                />
              </Link>

              <hr />

              <Link to="/main/rewards/form" className="linkRewards">
                <ContentHeader
                  icon="upload"
                  header={i18n.translate('rewards.home.submitBooking')}
                  subtitle={i18n.translate('rewards.home.submitBookingText')}
                  layout="row"
                />
              </Link>

              <hr />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardsView;
